import { cancel, delay, fork, put, select } from "redux-saga/effects";

import { GET_SEARCH_RESULTS } from "../../../../constants/SearchConstants";
import getSearchKeywordSelector from "./../../../selectors/SearchSelectors/getSearchKeywordSelector";

let minTask: any;
export default function* setSearchKeywordSaga({ keyword }: any): any {
    if (minTask) {
        yield cancel(minTask);
    }
    minTask = yield fork(waitMinTask);
}

function* waitMinTask(minTime = 500): any {
    try {
        yield delay(minTime);
        const keyword = yield select(getSearchKeywordSelector);
        if (keyword.length > 3) {
            yield put({ type: GET_SEARCH_RESULTS });
        }
    } catch (error) {}
}
